import { DemoScript } from './demo-script.types';

/**
 * "Add a product" — open the products list, start a new product, fill name,
 * price and description, and save. The SKU auto-generates from the name and the
 * unit/currency/VAT default on load, so the script types only the essentials.
 */
export const productScript: DemoScript = async (ctx) => {
  await ctx.goto('/dashboard?mockData=true');
  await ctx.wait(1200);

  ctx.say('Sol menüden Ürünler & Hizmetler sayfasına geçiyoruz');
  await ctx.click('nav-products');
  await ctx.wait(900);

  ctx.say('Yeni bir ürün/hizmet kartı eklemek için “Yeni Ürün” butonuna tıklıyoruz');
  await ctx.click('new-product');
  await ctx.wait(700);

  ctx.say('Ürünün adını yazıyoruz — Ürün Kodu (SKU) otomatik oluşturulur');
  await ctx.type('prod-name', 'name', 'Mobil Uygulama Geliştirme Paketi');

  ctx.say('Bunun bir Ürün mü yoksa Hizmet mi olduğunu buradan seçeriz — Hizmet seçilince stok takibi kapanır');
  await ctx.focus('prod-type');

  ctx.say('Birim satış fiyatını giriyoruz');
  await ctx.set('prod-price', 'unitPrice', 18500);

  ctx.say('Para birimi otomatik TRY (₺) gelir; istersek buradan değiştirebiliriz');
  await ctx.focus('prod-currency');

  ctx.say('Varsayılan KDV oranı %20 gelir; bunu da buradan değiştirebiliriz');
  await ctx.focus('prod-vat');

  ctx.say('Faturalara kopyalanacak varsayılan açıklamayı ekliyoruz');
  await ctx.type('prod-desc', 'defaultDescription', 'iOS ve Android için uçtan uca uygulama geliştirme.');
  await ctx.wait(400);

  ctx.say('“Kaydet” diyerek ürünü kataloğa ekliyoruz');
  await ctx.click('prod-save');
  await ctx.wait(1800);
};
